export default __webpack_public_path__ + "static/media/fMonth.d857b443.webp";